module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.addSite || _vm.siteData) ? _c('popup', {
    attrs: {
      "buttonStyle": this.addSite ? "success" : "info",
      "heading": this.addSite ? "New Site" : "Update Site",
      "buttonSize": "default",
      "size": "medium",
      "disable-button": !_vm.isManager('project|maintenance|property|finance|admin|management'),
      "button-text": _vm.addSite ? "Add" : "Edit",
      "button-icon": _vm.addSite ? "fa fa-tower-broadcast" :
        "fa fa-pencil-alt"
    },
    on: {
      "save": _vm.onSaveDialog,
      "close": _vm.onCloseDialog
    }
  }, [_c('el-form', {
    ref: "siteForm",
    attrs: {
      "model": _vm.site,
      "rules": _vm.rules,
      "label-position": "top",
      "inline": ""
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24,
      "align": "center"
    }
  }, [_c('h4', [_vm._v("Site Name: "), _c('span', {
    class: _vm.titleClass(_vm.site.status)
  }, [_vm._v(_vm._s(_vm.site.siteName ? _vm.site.siteName : 'not entered'))])])])], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Details",
      "name": "site"
    }
  }, [(_vm.site.status === this.soldSite()) ? _c('div', [_c('el-alert', {
    attrs: {
      "type": "error",
      "closable": false,
      "show-icon": "",
      "title": "Sold Site Warning!",
      "description": "If you save, ALL sharers will be set to 'Terminated'! Plus you won't be able to edit site details anymore."
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('select-site-status', {
    ref: "selectSite",
    attrs: {
      "label": "Status",
      "required": "",
      "disabled": this.isDisabled(_vm.originalSite, _vm.site, 'status')
    },
    model: {
      value: (_vm.site.status),
      callback: function($$v) {
        _vm.$set(_vm.site, "status", $$v)
      },
      expression: "site.status"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Site Name",
      "prop": "siteName",
      "required": "",
      "placeholder": "Site Name",
      "disabled": this.isDisabled(_vm.originalSite, _vm.site, 'siteName')
    },
    model: {
      value: (_vm.site.siteName),
      callback: function($$v) {
        _vm.$set(_vm.site, "siteName", $$v)
      },
      expression: "site.siteName"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Site ID",
      "prop": "siteId",
      "required": "",
      "placeholder": "Site ID",
      "max-length": 16,
      "disabled": this.isDisabled(_vm.originalSite, _vm.site, 'siteId')
    },
    model: {
      value: (_vm.site.siteId),
      callback: function($$v) {
        _vm.$set(_vm.site, "siteId", $$v)
      },
      expression: "site.siteId"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Site Group",
      "prop": "siteGroup",
      "placeholder": "Site Group",
      "max-length": 16,
      "disabled": this.isDisabled(_vm.originalSite, _vm.site, 'siteGroup')
    },
    model: {
      value: (_vm.site.siteGroup),
      callback: function($$v) {
        _vm.$set(_vm.site, "siteGroup", $$v)
      },
      expression: "site.siteGroup"
    }
  }), _vm._v(" "), _c('select-coverage', {
    attrs: {
      "label": "Coverage",
      "disabled": this.isDisabled(_vm.originalSite, _vm.site, 'coverage')
    },
    model: {
      value: (_vm.site.coverage),
      callback: function($$v) {
        _vm.$set(_vm.site, "coverage", $$v)
      },
      expression: "site.coverage"
    }
  }), _vm._v(" "), _c('date-input', {
    attrs: {
      "label": "Handover",
      "prop": "handover",
      "disabled": this.isDisabled(_vm.originalSite, _vm.site, 'handover')
    },
    model: {
      value: (_vm.site.handover),
      callback: function($$v) {
        _vm.$set(_vm.site, "handover", $$v)
      },
      expression: "site.handover"
    }
  }), _vm._v(" "), (_vm.site.status === this.activeSite()) ? _c('date-input', {
    attrs: {
      "label": "Active",
      "prop": "active",
      "disabled": this.isDisabled(_vm.originalSite, _vm.site, 'active')
    },
    model: {
      value: (_vm.site.active),
      callback: function($$v) {
        _vm.$set(_vm.site, "active", $$v)
      },
      expression: "site.active"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.site.status === this.dismantledSite()) ? _c('date-input', {
    attrs: {
      "label": "Dismantled",
      "prop": "dismantled",
      "disabled": this.isDisabled(_vm.originalSite, _vm.site, 'dismantled')
    },
    model: {
      value: (_vm.site.dismantled),
      callback: function($$v) {
        _vm.$set(_vm.site, "dismantled", $$v)
      },
      expression: "site.dismantled"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24,
      "align": "center"
    }
  }, [(!_vm.addSite && _vm.isManager('project|management')) ? _c('check-box', {
    model: {
      value: (_vm.override),
      callback: function($$v) {
        _vm.override = $$v
      },
      expression: "override"
    }
  }, [_c('b', [_vm._v("Manager Only!")]), _vm._v(" Change existing data?")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.addSite && this.isCandidate(_vm.site.status)) ? _c('el-tab-pane', {
    attrs: {
      "label": "Candidate"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('select-sharer', {
    model: {
      value: (_vm.candidate.client_id),
      callback: function($$v) {
        _vm.$set(_vm.candidate, "client_id", $$v)
      },
      expression: "candidate.client_id"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Your Ref",
      "placeholder": "Your Ref",
      "max-length": 16
    },
    model: {
      value: (_vm.candidate.clientRef),
      callback: function($$v) {
        _vm.$set(_vm.candidate, "clientRef", $$v)
      },
      expression: "candidate.clientRef"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Title",
      "placeholder": "Title",
      "max-length": 88
    },
    model: {
      value: (_vm.candidate.title),
      callback: function($$v) {
        _vm.$set(_vm.candidate, "title", $$v)
      },
      expression: "candidate.title"
    }
  }), _vm._v(" "), _c('select-coverage', {
    attrs: {
      "label": "Station Type"
    },
    model: {
      value: (_vm.candidate.stationType),
      callback: function($$v) {
        _vm.$set(_vm.candidate, "stationType", $$v)
      },
      expression: "candidate.stationType"
    }
  }), _vm._v(" "), _c('integer-input', {
    attrs: {
      "label": "Antenna AGL",
      "min": 1,
      "max": 121,
      "suffix": "m.",
      "placeholder": "Height above ground in metres"
    },
    model: {
      value: (_vm.candidate.antennaHeight),
      callback: function($$v) {
        _vm.$set(_vm.candidate, "antennaHeight", $$v)
      },
      expression: "candidate.antennaHeight"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addSite && !_vm.isLandOnly(_vm.site.status) && _vm.struct) ? _c('el-tab-pane', {
    attrs: {
      "label": "Structure",
      "name": "structure"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": _vm.guts
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('select-structure', {
    attrs: {
      "label": "Structure Type",
      "disabled": _vm.isDisabled(_vm.originalStruct, _vm.struct, 'structure_id')
    },
    model: {
      value: (_vm.struct.structure_id),
      callback: function($$v) {
        _vm.$set(_vm.struct, "structure_id", $$v)
      },
      expression: "struct.structure_id"
    }
  }), _vm._v(" "), _c('select-tower-supplier', {
    attrs: {
      "disabled": _vm.isDisabled(_vm.originalStruct, _vm.struct, 'supplier_id')
    },
    model: {
      value: (_vm.struct.supplier_id),
      callback: function($$v) {
        _vm.$set(_vm.struct, "supplier_id", $$v)
      },
      expression: "struct.supplier_id"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.guts
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('integer-input', {
    attrs: {
      "label": "Structure Height",
      "min": 1,
      "max": 121,
      "suffix": "m.",
      "disabled": _vm.isDisabled(_vm.originalStruct, _vm.struct, 'height')
    },
    model: {
      value: (_vm.struct.height),
      callback: function($$v) {
        _vm.$set(_vm.struct, "height", $$v)
      },
      expression: "struct.height"
    }
  }), _vm._v(" "), _c('integer-input', {
    attrs: {
      "label": "Design Weight",
      "min": 1,
      "max": 121,
      "suffix": "kgs.",
      "placeholder": "weight in kgs.",
      "disabled": _vm.isDisabled(_vm.originalStruct, _vm.struct, 'weight')
    },
    model: {
      value: (_vm.struct.weight),
      callback: function($$v) {
        _vm.$set(_vm.struct, "weight", $$v)
      },
      expression: "struct.weight"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.guts
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('integer-input', {
    attrs: {
      "label": "Site Width",
      "suffix": "m.",
      "placeholder": "width in metres",
      "disabled": this.isDisabled(_vm.originalStruct, _vm.struct, 'width')
    },
    model: {
      value: (_vm.struct.width),
      callback: function($$v) {
        _vm.$set(_vm.struct, "width", $$v)
      },
      expression: "struct.width"
    }
  }), _vm._v(" "), _c('integer-input', {
    attrs: {
      "label": "Site Depth",
      "suffix": "m.",
      "placeholder": "depth in metres",
      "disabled": this.isDisabled(_vm.originalStruct, _vm.struct, 'depth')
    },
    model: {
      value: (_vm.struct.depth),
      callback: function($$v) {
        _vm.$set(_vm.struct, "depth", $$v)
      },
      expression: "struct.depth"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Locality",
      "name": "locality"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": _vm.guts
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('text-input', {
    staticStyle: {
      "width": "100%",
      "height": "100px"
    },
    attrs: {
      "label": "Address",
      "type": "textarea",
      "placeholder": "Site Address",
      "disabled": this.isDisabled(_vm.originalSite, _vm.site, 'address')
    },
    model: {
      value: (_vm.site.address),
      callback: function($$v) {
        _vm.$set(_vm.site, "address", $$v)
      },
      expression: "site.address"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Post Code",
      "prop": "postCode",
      "placeholder": "Post Code",
      "disabled": this.isDisabled(_vm.originalSite, _vm.site, 'postCode')
    },
    model: {
      value: (_vm.site.postCode),
      callback: function($$v) {
        _vm.$set(_vm.site, "postCode", $$v)
      },
      expression: "site.postCode"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('select-locality', {
    attrs: {
      "label": "District",
      "disabled": _vm.isDisabled(_vm.originalSite,
        _vm.site,
        ['zone', 'subdistrict', 'district', 'state', 'region', 'country'])
    },
    model: {
      value: (_vm.loc),
      callback: function($$v) {
        _vm.loc = $$v
      },
      expression: "loc"
    }
  })], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.guts
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8,
      "align": "center"
    }
  }, [(!_vm.movePos) ? _c('float-input', {
    attrs: {
      "type": "number",
      "decimals": 12,
      "placeholder": "Latitude",
      "prefix": "Lat",
      "suffix": "&deg;",
      "disabled": this.isDisabled(_vm.originalSite, _vm.site, 'latitude')
    },
    model: {
      value: (_vm.site.latitude),
      callback: function($$v) {
        _vm.$set(_vm.site, "latitude", $$v)
      },
      expression: "site.latitude"
    }
  }) : _c('span', [_vm._v("Latitude: "), _c('b', [_vm._v(_vm._s(_vm.site.latitude))]), _vm._v("°")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "align": "center"
    }
  }, [(!_vm.movePos) ? _c('float-input', {
    attrs: {
      "decimals": 12,
      "type": "number",
      "placeholder": "Longitude",
      "prefix": "Lng",
      "suffix": "&deg;",
      "disabled": this.isDisabled(_vm.originalSite, _vm.site, 'longitude')
    },
    model: {
      value: (_vm.site.longitude),
      callback: function($$v) {
        _vm.$set(_vm.site, "longitude", $$v)
      },
      expression: "site.longitude"
    }
  }) : _c('span', [_vm._v("Longitude: "), _c('b', [_vm._v(_vm._s(_vm.site.longitude))]), _vm._v("°")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "align": "center"
    }
  }, [_c('float-input', {
    attrs: {
      "type": "number",
      "decimals": 2,
      "placeholder": "AGL",
      "prefix": "AGL",
      "suffix": "&deg;",
      "disabled": this.isDisabled(_vm.originalSite, _vm.site, 'latitude')
    },
    model: {
      value: (_vm.site.agl),
      callback: function($$v) {
        _vm.$set(_vm.site, "agl", $$v)
      },
      expression: "site.agl"
    }
  })], 1)], 1), _vm._v(" "), (this.site.latitude && this.site.longitude) ? _c('google-map', {
    attrs: {
      "lat": this.site.latitude,
      "lng": this.site.longitude,
      "draggable": "",
      "zoom": 14,
      "width": "100%",
      "height": "41.7vh"
    },
    on: {
      "update": _vm.updateSiteMap
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.addSite) ? _c('el-tab-pane', {
    attrs: {
      "label": "Tenancy",
      "name": "tenancy"
    }
  }, [_c('update-tenancy', {
    attrs: {
      "site-data": _vm.site,
      "tenancy-data": _vm.tenancy,
      "adding": "",
      "editable": "",
      "no-disable": ""
    },
    on: {
      "update": _vm.updateTenancy
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.addSite && !_vm.isLandOnly(_vm.site.status) && _vm.finance) ? _c('el-tab-pane', {
    attrs: {
      "label": "Finance",
      "name": "finance"
    }
  }, [_c('number-input', {
    attrs: {
      "label": "Site CAPEX",
      "prop": "capex",
      "placeholder": "Site CAPEX",
      "disabled": this.isDisabled(_vm.originalFinance, _vm.finance, 'capex')
    },
    model: {
      value: (_vm.finance.capex),
      callback: function($$v) {
        _vm.$set(_vm.finance, "capex", $$v)
      },
      expression: "finance.capex"
    }
  }), _vm._v(" "), _c('number-input', {
    attrs: {
      "label": "Site OPEX",
      "prop": "opex",
      "placeholder": "Site OPEX",
      "disabled": this.isDisabled(_vm.originalFinance, _vm.finance, 'opex')
    },
    model: {
      value: (_vm.finance.opex),
      callback: function($$v) {
        _vm.$set(_vm.finance, "opex", $$v)
      },
      expression: "finance.opex"
    }
  })], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ef98a64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/SiteAction.vue
// module id = 1325
// module chunks = 0